import type { UserRole } from "@/lib/auth/session";

export type NavItem = {
  href: string;
  label: string;
  /** Icon key resolved by the sidebar's icon map. */
  icon: "dashboard" | "upload" | "workbooks" | "profiles" | "settings" | "users";
  /** Only render the link when the signed-in user has this role. */
  requiresRole?: UserRole;
};

export const navItems: NavItem[] = [
  { href: "/", label: "Dashboard", icon: "dashboard" },
  { href: "/workbooks", label: "Workbooks", icon: "workbooks" },
  { href: "/profiles", label: "Templates", icon: "profiles" },
  { href: "/members", label: "Members", icon: "users" },
  { href: "/settings", label: "Settings", icon: "settings" },
];

export function visibleNavItems(role: UserRole): NavItem[] {
  return navItems.filter((item) => !item.requiresRole || item.requiresRole === role);
}

/** Best-matching nav item for a pathname (longest href prefix wins). */
export function activeNavItem(pathname: string, role: UserRole): NavItem | undefined {
  const items = visibleNavItems(role);
  let best: NavItem | undefined;
  for (const item of items) {
    const matches =
      item.href === "/" ? pathname === "/" : pathname.startsWith(item.href);
    if (!matches) continue;
    if (!best || item.href.length > best.href.length) best = item;
  }
  return best;
}
